module.exports = __webpack_public_path__ + "static/api_key_form-7aa93ae2f5179cf4363615de275fa4c9.png";